import React, { useState } from 'react';
import Header from '../components/Header';

const C = {
  servizi: '#009045',
  serviziDark: '#006f35',
  serviziLight: '#e8f5ee',
  trasporto: '#EB1C24',
  alloggio: '#0071BA',
  attivita: '#FF5B00',
  dark: '#0a1628',
  white: '#ffffff',
  text: '#1a1a2e',
  textLight: '#6b7280',
  border: '#e5e7eb',
  light: '#f5f7fa',
};

const TIPOLOGIE = [
  {
    id: 'noleggio-auto',
    emoji: '🚗',
    nome: 'Noleggio Auto',
    tagline: 'Libertà di muoversi ovunque',
    descrizione: 'Confronta le principali compagnie di noleggio in aeroporto, stazione o in città. Scegli la classe di veicolo e verifica cosa è incluso nell\'assicurazione prima di prenotare.',
    perchi: ['Famiglie', 'Viaggi on the road', 'Zone poco servite'],
    prezzo: '€€ – €€€',
    cosa_confronti: [
      { ico: '🏢', txt: 'Operatori: Hertz, Europcar, Sixt, Avis, Goldcar e aggregatori' },
      { ico: '🚙', txt: 'Classe veicolo: city car, berlina, SUV, furgone, automatico' },
      { ico: '🛡️', txt: 'Assicurazione inclusa: CDW, furto, danni terzi e franchigia' },
      { ico: '📍', txt: 'Ritiro in aeroporto, stazione o in città — restituzione flessibile' },
      { ico: '⛽', txt: 'Politica carburante: pieno/pieno o pieno/vuoto' },
      { ico: '👶', txt: 'Seggiolini bambini, GPS e conducente aggiuntivo' },
    ],
  },
  {
    id: 'noleggio-bici',
    emoji: '🚲',
    nome: 'Noleggio Bici e Scooter',
    tagline: 'Muoviti in modo sostenibile',
    descrizione: 'Bici tradizionale, e-bike, scooter elettrico o moto: confronta noleggi orari, giornalieri o settimanali per esplorare la destinazione in libertà e a basso impatto.',
    perchi: ['Eco-viaggiatori', 'City explorer', 'Brevi spostamenti'],
    prezzo: '€ – €€',
    cosa_confronti: [
      { ico: '🚲', txt: 'Bici tradizionale, e-bike, scooter elettrico o moto' },
      { ico: '⏱️', txt: 'Tariffe orarie, giornaliere o settimanali' },
      { ico: '🔒', txt: 'Lucchetto, casco e kit riparazione inclusi' },
      { ico: '🗺️', txt: 'Mappa percorsi ciclabili e consigli sul territorio' },
      { ico: '🔋', txt: 'Autonomia e-bike: km stimati per carica' },
      { ico: '📍', txt: 'Punti di ritiro, riconsegna flessibile e assistenza' },
    ],
  },
  {
    id: 'transfer',
    emoji: '🚐',
    nome: 'Transfer Aeroportuale',
    tagline: 'Dall\'aeroporto all\'hotel senza stress',
    descrizione: 'Confronta navette condivise, taxi privati, treni e bus per raggiungere la città dall\'aeroporto. Prenota in anticipo e dimentica le code ai taxi.',
    perchi: ['Tutti i viaggiatori', 'Arrivi notturni', 'Famiglie con bagagli'],
    prezzo: '€ – €€€',
    cosa_confronti: [
      { ico: '🚌', txt: 'Navetta condivisa: economica ma con fermate intermedie' },
      { ico: '🚖', txt: 'Taxi privato: diretto all\'hotel, prezzo fisso' },
      { ico: '🚂', txt: 'Treno aeroportuale: rapido, puntuale, più economico' },
      { ico: '🚐', txt: 'Minivan privato per gruppi e famiglie numerose' },
      { ico: '⏱️', txt: 'Tempo stimato di percorrenza per ogni opzione' },
      { ico: '✈️', txt: 'Monitoraggio volo in ritardo — autista adeguato automaticamente' },
    ],
  },
  {
    id: 'assicurazione',
    emoji: '🛡️',
    nome: 'Assicurazioni Viaggio',
    tagline: 'Viaggia senza pensieri',
    descrizione: 'Confronta polizze di annullamento viaggio, copertura medica all\'estero, tutela del bagaglio e assistenza 24/7. Scegli la copertura giusta in base alla destinazione e al tipo di viaggio.',
    perchi: ['Tutti i viaggiatori', 'Destinazioni extra-UE', 'Sport ad alto rischio'],
    prezzo: '€ – €€',
    cosa_confronti: [
      { ico: '❌', txt: 'Annullamento viaggio: rimborso per malattia, problemi lavoro, ecc.' },
      { ico: '🏥', txt: 'Copertura medica: spese ospedaliere, rimpatrio, dentista' },
      { ico: '🧳', txt: 'Bagaglio: furto, smarrimento, ritardo consegna' },
      { ico: '🤿', txt: 'Attività sportive: trekking, sci, moto, diving — copertura specifica' },
      { ico: '📞', txt: 'Assistenza 24/7 in italiano — numero verde incluso' },
      { ico: '🌍', txt: 'Massimale medico e Schenghen card per visti' },
    ],
  },
  {
    id: 'abbonamenti',
    emoji: '🎫',
    nome: 'Abbonamenti e Mezzi Pubblici',
    tagline: 'Muoviti in città come un locale',
    descrizione: 'City card, pass turistici, abbonamenti giornalieri e settimanali per metro, bus e tram. Confronta cosa è incluso e quanto conviene rispetto ai biglietti singoli.',
    perchi: ['Soggiorni urbani', 'Turisti attivi', 'Famiglie'],
    prezzo: '€ – €€',
    cosa_confronti: [
      { ico: '🗓️', txt: 'Pass: 24h, 48h, 72h, settimanale o mensile' },
      { ico: '🏙️', txt: 'City card: trasporti + ingressi musei + sconti ristoranti' },
      { ico: '🚇', txt: 'Copertura: metro, bus, tram, treni suburbani, traghetti' },
      { ico: '💶', txt: 'Confronto costo vs. biglietti singoli per N giorni' },
      { ico: '📱', txt: 'App ufficiale e validazione digitale vs. tessera fisica' },
      { ico: '👨‍👩‍👧', txt: 'Tariffe famiglia, ridotti under 18 e over 65' },
    ],
  },
  {
    id: 'sim',
    emoji: '📱',
    nome: 'SIM e Connettività',
    tagline: 'Sempre connesso, ovunque',
    descrizione: 'SIM locale, eSIM internazionale o pocket WiFi: confronta la soluzione migliore per restare connesso durante il viaggio senza costi di roaming imprevisti.',
    perchi: ['Viaggiatori frequenti', 'Smart worker', 'Famiglie in gruppo'],
    prezzo: '€ – €€',
    cosa_confronti: [
      { ico: '📶', txt: 'GB inclusi, velocità 4G/5G e copertura nel paese' },
      { ico: '📲', txt: 'eSIM: attivazione digitale senza SIM fisica' },
      { ico: '📡', txt: 'Pocket WiFi: condivisione fino a 5-10 dispositivi' },
      { ico: '☎️', txt: 'Minuti e SMS inclusi per chiamate locali' },
      { ico: '⏱️', txt: 'Validità: giornaliera, settimanale o mensile' },
      { ico: '🌍', txt: 'Copertura multi-paese per itinerari in più stati' },
    ],
  },
];

const STEPS = [
  {
    num: '1',
    titolo: 'Seleziona i servizi',
    testo: 'Attiva solo le categorie che ti servono. Per una settimana a Barcellona potresti voler solo abbonamento mezzi + assicurazione.',
    colore: C.servizi,
  },
  {
    num: '2',
    titolo: 'Inserisci i dettagli',
    testo: 'Date di viaggio, numero di persone, destinazione: i risultati si adattano in automatico al tuo profilo di viaggio.',
    colore: C.alloggio,
  },
  {
    num: '3',
    titolo: 'Confronta le offerte',
    testo: 'Vedi prezzo, copertura e condizioni affiancati. Nessuna sorpresa al momento del pagamento.',
    colore: C.attivita,
  },
  {
    num: '4',
    titolo: 'Completa l\'esperienza',
    testo: 'I servizi scelti completano la tua esperienza OCTA insieme a trasporto, alloggio e attività.',
    colore: C.trasporto,
  },
];

export default function Servizi() {
  const [attive, setAttive] = useState(new Set(TIPOLOGIE.map(t => t.id)));
  const [aperta, setAperta] = useState(null);

  const toggleTipo = (id) => {
    setAttive(prev => {
      const next = new Set(prev);
      if (next.has(id)) {
        if (next.size > 1) next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  };

  const selezionaTutte = () => setAttive(new Set(TIPOLOGIE.map(t => t.id)));
  const tipologieVisibili = TIPOLOGIE.filter(t => attive.has(t.id));

  return (
    <div style={{ minHeight: '100vh', backgroundColor: C.light, fontFamily: 'Roboto, sans-serif', color: C.text }}>
      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; }
        a { text-decoration: none; }
        button { cursor: pointer; font-family: 'Roboto', sans-serif; }
        button:hover { opacity: 0.88; }
        .octa-hamburger { display: none; }
        @media (max-width: 1024px) {
          .octa-header { padding: 12px 24px !important; }
          .octa-hero { padding: 52px 32px 60px !important; }
          .octa-hero h1 { font-size: 38px !important; }
          .octa-section { padding: 52px 32px !important; }
          .octa-footer { padding: 24px 32px !important; }
        }
        @media (max-width: 640px) {
          .octa-hamburger { display: flex !important; align-items: center; }
          .octa-header { padding: 12px 16px !important; }
          .octa-nav-link { display: none !important; }
          .octa-hero { padding: 48px 20px 56px !important; }
          .octa-hero h1 { font-size: 34px !important; }
          .octa-section { padding: 48px 20px !important; }
          .octa-card-grid { grid-template-columns: 1fr !important; }
          .octa-steps-grid { grid-template-columns: 1fr !important; }
          .octa-footer { padding: 24px 16px !important; flex-direction: column !important; align-items: flex-start !important; gap: 16px !important; }
          .octa-cta-btns { flex-direction: column !important; }
          .octa-cta-btns a { text-align: center !important; }
        }
        @media (max-width: 900px) {
          .octa-card-grid { grid-template-columns: 1fr 1fr !important; }
          .octa-steps-grid { grid-template-columns: 1fr 1fr !important; }
        }
        .tipo-pill { transition: all 0.15s ease; }
        .tipo-pill:hover { transform: translateY(-1px); }
        .card-srv { transition: box-shadow 0.15s ease; }
        .card-srv:hover { box-shadow: 0 8px 32px rgba(0,144,69,0.12); }
      `}</style>

      <Header bg={C.servizi} />

      {/* HERO */}
      <section className="octa-hero" style={{ backgroundColor: C.servizi, padding: '68px 60px 76px', textAlign: 'center', position: 'relative', overflow: 'hidden' }}>
        <div style={{ maxWidth: '760px', margin: '0 auto' }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', padding: '7px 18px', borderRadius: '50px', backgroundColor: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)', marginBottom: '28px' }}>
            <img src="/images/servizi_icona.png" alt="Servizi" style={{ height: '18px' }} onError={e => { e.target.style.display = 'none'; }} />
            <span style={{ fontSize: '13px', fontWeight: 700, color: C.white, letterSpacing: '0.06em', textTransform: 'uppercase' }}>Segmento Servizi</span>
          </div>
          <h1 style={{ fontSize: '50px', fontWeight: 900, color: C.white, lineHeight: 1.1, marginBottom: '20px' }}>
            I dettagli pratici,<br />
            <span style={{ color: C.white }}>risolti in anticipo.</span>
          </h1>
          <p style={{ fontSize: '17px', color: 'rgba(255,255,255,0.85)', lineHeight: 1.75, maxWidth: '600px', margin: '0 auto 36px' }}>
            Noleggio auto, transfer, assicurazioni, abbonamenti mezzi e connettività: confronta i servizi pratici e tieni solo quelli che ti servono davvero per quel viaggio.
          </p>
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
            {TIPOLOGIE.map(t => (
              <span key={t.id} style={{ padding: '6px 14px', borderRadius: '50px', backgroundColor: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)', color: C.white, fontSize: '13px', fontWeight: 600 }}>
                {t.emoji} {t.nome}
              </span>
            ))}
          </div>
        </div>
      </section>

      {/* BANNER COMING SOON */}
      <div style={{ backgroundColor: '#fffbeb', borderBottom: '1px solid #fde68a', padding: '13px 40px', textAlign: 'center' }}>
        <p style={{ fontSize: '14px', color: '#92400e', fontWeight: 600 }}>
          🚀 La ricerca comparativa in tempo reale è in arrivo — per ora condividi i servizi usati nei tuoi viaggi e scopri quelli della community.
        </p>
      </div>

      {/* SELETTORE TIPOLOGIE */}
      <section className="octa-section" style={{ padding: '64px 60px', backgroundColor: C.white }}>
        <div style={{ maxWidth: '1060px', margin: '0 auto' }}>
          <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', flexWrap: 'wrap', gap: '16px', marginBottom: '36px' }}>
            <div>
              <p style={{ fontSize: '12px', fontWeight: 700, color: C.servizi, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '10px' }}>Personalizza la ricerca</p>
              <h2 style={{ fontSize: '32px', fontWeight: 900, color: C.text, lineHeight: 1.2 }}>Seleziona i servizi che ti interessano</h2>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <span style={{ fontSize: '13px', color: C.textLight }}>{attive.size} di {TIPOLOGIE.length} attivi</span>
              {attive.size < TIPOLOGIE.length && (
                <button onClick={selezionaTutte} style={{ padding: '7px 16px', borderRadius: '20px', border: `1px solid ${C.servizi}`, backgroundColor: 'transparent', color: C.servizi, fontSize: '13px', fontWeight: 600 }}>
                  Seleziona tutti
                </button>
              )}
            </div>
          </div>

          {/* PILL SELECTOR */}
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', marginBottom: '48px' }}>
            {TIPOLOGIE.map(t => {
              const isOn = attive.has(t.id);
              return (
                <button
                  key={t.id}
                  className="tipo-pill"
                  onClick={() => toggleTipo(t.id)}
                  style={{
                    display: 'flex', alignItems: 'center', gap: '9px',
                    padding: '11px 22px', borderRadius: '50px',
                    border: `2px solid ${isOn ? C.servizi : C.border}`,
                    backgroundColor: isOn ? C.servizi : C.white,
                    color: isOn ? C.white : C.textLight,
                    fontSize: '14px', fontWeight: 700,
                    boxShadow: isOn ? `0 4px 16px rgba(0,144,69,0.25)` : 'none',
                  }}
                >
                  <span style={{ fontSize: '18px' }}>{t.emoji}</span>
                  {t.nome}
                  {isOn && <span style={{ fontSize: '12px', opacity: 0.75 }}>✓</span>}
                </button>
              );
            })}
          </div>

          {/* GRIGLIA CARD */}
          <div className="octa-card-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px' }}>
            {tipologieVisibili.map(t => {
              const isAperta = aperta === t.id;
              return (
                <div
                  key={t.id}
                  className="card-srv"
                  style={{ backgroundColor: C.white, borderRadius: '18px', border: `1px solid ${isAperta ? C.servizi : C.border}`, borderTop: `3px solid ${C.servizi}`, overflow: 'hidden', cursor: 'pointer' }}
                  onClick={() => setAperta(isAperta ? null : t.id)}
                >
                  <div style={{ padding: '24px 24px 20px', borderBottom: `1px solid ${C.border}` }}>
                    <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '12px', marginBottom: '12px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <span style={{ fontSize: '28px' }}>{t.emoji}</span>
                        <div>
                          <h3 style={{ fontSize: '17px', fontWeight: 800, color: C.text }}>{t.nome}</h3>
                          <p style={{ fontSize: '11px', color: C.servizi, fontWeight: 700 }}>{t.tagline}</p>
                        </div>
                      </div>
                      <span style={{ fontSize: '18px', color: C.textLight, flexShrink: 0, marginTop: '2px' }}>{isAperta ? '▲' : '▼'}</span>
                    </div>
                    <p style={{ fontSize: '13px', color: C.textLight, lineHeight: 1.6 }}>{t.descrizione}</p>
                  </div>
                  <div style={{ padding: '14px 24px', display: 'flex', gap: '16px', flexWrap: 'wrap', alignItems: 'center' }}>
                    <div>
                      <p style={{ fontSize: '10px', fontWeight: 700, color: C.textLight, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '3px' }}>Prezzo medio</p>
                      <p style={{ fontSize: '14px', fontWeight: 800, color: C.servizi }}>{t.prezzo}</p>
                    </div>
                    <div style={{ width: '1px', height: '28px', backgroundColor: C.border }} />
                    <div>
                      <p style={{ fontSize: '10px', fontWeight: 700, color: C.textLight, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '4px' }}>Ideale per</p>
                      <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
                        {t.perchi.map(p => (
                          <span key={p} style={{ padding: '2px 8px', borderRadius: '10px', backgroundColor: C.serviziLight, color: C.servizi, fontSize: '11px', fontWeight: 600 }}>{p}</span>
                        ))}
                      </div>
                    </div>
                  </div>
                  {isAperta && (
                    <div style={{ padding: '0 24px 20px', borderTop: `1px solid ${C.border}` }}>
                      <p style={{ fontSize: '11px', fontWeight: 700, color: C.textLight, textTransform: 'uppercase', letterSpacing: '0.08em', margin: '16px 0 12px' }}>Cosa puoi confrontare</p>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '9px' }}>
                        {t.cosa_confronti.map((v, i) => (
                          <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                            <span style={{ fontSize: '15px', flexShrink: 0, marginTop: '1px' }}>{v.ico}</span>
                            <span style={{ fontSize: '13px', color: C.text, lineHeight: 1.5 }}>{v.txt}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          {tipologieVisibili.length > 0 && (
            <p style={{ fontSize: '13px', color: C.textLight, textAlign: 'center', marginTop: '20px' }}>
              Clicca su una card per vedere nel dettaglio cosa puoi confrontare.
            </p>
          )}
        </div>
      </section>

      {/* COME FUNZIONA */}
      <section className="octa-section" style={{ padding: '72px 60px', backgroundColor: C.light }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '52px' }}>
            <p style={{ fontSize: '12px', fontWeight: 700, color: C.servizi, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '12px' }}>Come funziona</p>
            <h2 style={{ fontSize: '34px', fontWeight: 900, color: C.text, marginBottom: '14px' }}>Prenota i servizi in 4 passi</h2>
            <p style={{ fontSize: '16px', color: C.textLight, maxWidth: '500px', margin: '0 auto' }}>
              I servizi pratici completano il viaggio. Confrontali prima di partire e risparmia tempo — e sorprese — una volta arrivato.
            </p>
          </div>
          <div className="octa-steps-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px' }}>
            {STEPS.map((step, i) => (
              <div key={i} style={{ padding: '28px 22px', borderRadius: '16px', backgroundColor: C.white, border: `1px solid ${C.border}`, borderTop: `3px solid ${step.colore}`, textAlign: 'center' }}>
                <div style={{ width: '44px', height: '44px', borderRadius: '50%', backgroundColor: step.colore, color: C.white, fontSize: '17px', fontWeight: 900, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>{step.num}</div>
                <h3 style={{ fontSize: '15px', fontWeight: 800, color: C.text, marginBottom: '10px' }}>{step.titolo}</h3>
                <p style={{ fontSize: '13px', color: C.textLight, lineHeight: 1.65 }}>{step.testo}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SEZIONE DARK: PERCHÉ I SERVIZI FANNO LA DIFFERENZA */}
      <section className="octa-section" style={{ padding: '72px 60px', backgroundColor: C.servizi }}>
        <div style={{ maxWidth: '860px', margin: '0 auto', textAlign: 'center' }}>
          <p style={{ fontSize: '12px', fontWeight: 700, color: 'rgba(255,255,255,0.85)', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '12px' }}>Perché è importante</p>
          <h2 style={{ fontSize: '32px', fontWeight: 900, color: C.white, marginBottom: '16px' }}>I servizi cambiano la qualità del viaggio</h2>
          <p style={{ fontSize: '16px', color: 'rgba(255,255,255,0.8)', lineHeight: 1.75, maxWidth: '580px', margin: '0 auto 44px' }}>
            Un transfer prenotato male, un\'assicurazione insufficiente o un roaming imprevisto possono rovinare anche il viaggio più organizzato. OCTA ti aiuta a confrontare tutto prima di partire.
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '14px' }}>
            {[
              { ico: '💸', titolo: 'Niente costi nascosti', desc: 'Vedi il prezzo completo prima di confermare: franchigie, supplementi e tasse incluse.' },
              { ico: '⏱️', titolo: 'Prenota in anticipo', desc: 'I servizi migliori si esauriscono. Organizzarsi prima significa risparmiare e avere più scelta.' },
              { ico: '🔗', titolo: 'Tutto collegato', desc: 'I servizi si integrano con trasporto e alloggio: vedi il quadro completo del viaggio.' },
              { ico: '🌍', titolo: 'Adatto alla destinazione', desc: 'I servizi consigliati cambiano in base alla meta: SIM locale per l\'Asia, city card per l\'Europa.' },
            ].map((f, i) => (
              <div key={i} style={{ padding: '22px 20px', borderRadius: '14px', backgroundColor: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.2)', textAlign: 'left' }}>
                <span style={{ fontSize: '26px', display: 'block', marginBottom: '10px' }}>{f.ico}</span>
                <h4 style={{ fontSize: '14px', fontWeight: 700, color: C.white, marginBottom: '7px' }}>{f.titolo}</h4>
                <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.75)', lineHeight: 1.6 }}>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="octa-section" style={{ padding: '80px 60px', backgroundColor: C.white, textAlign: 'center' }}>
        <div style={{ maxWidth: '580px', margin: '0 auto' }}>
          <div style={{ width: '64px', height: '64px', borderRadius: '18px', backgroundColor: C.serviziLight, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px', fontSize: '30px' }}>🛡️</div>
          <h2 style={{ fontSize: '32px', fontWeight: 900, color: C.text, marginBottom: '14px' }}>Quali servizi hai usato?<br />Aiuta chi viene dopo di te.</h2>
          <p style={{ fontSize: '16px', color: C.textLight, lineHeight: 1.7, marginBottom: '36px' }}>
            Il noleggio auto conveniente, la city card che valeva davvero la pena: aggiungi i servizi alla tua esperienza OCTA e risparmia tempo a chi andrà nella stessa destinazione.
          </p>
          <div className="octa-cta-btns" style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href="/crea" style={{ padding: '15px 32px', borderRadius: '50px', backgroundColor: C.servizi, color: C.white, fontSize: '15px', fontWeight: 700 }}>
              + Crea un'esperienza
            </a>
            <a href="/bacheca" style={{ padding: '15px 32px', borderRadius: '50px', border: `2px solid ${C.border}`, color: C.textLight, fontSize: '15px', fontWeight: 600 }}>
              Esplora la bacheca
            </a>
          </div>
        </div>
      </section>

      {/* ALTRI SEGMENTI */}
      <section style={{ padding: '40px 60px', backgroundColor: C.light, borderTop: `1px solid ${C.border}` }}>
        <div style={{ maxWidth: '900px', margin: '0 auto', textAlign: 'center' }}>
          <p style={{ fontSize: '12px', fontWeight: 700, color: C.textLight, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '18px' }}>Esplora gli altri segmenti</p>
          <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
            {[
              { label: 'Trasporto', color: C.trasporto, href: '/trasporto' },
              { label: 'Alloggio', color: C.alloggio, href: '/alloggio' },
              { label: 'Attività', color: C.attivita, href: '/attivita' },
            ].map(seg => (
              <a key={seg.label} href={seg.href} style={{ padding: '10px 24px', borderRadius: '50px', border: `2px solid ${seg.color}`, color: seg.color, fontSize: '14px', fontWeight: 700, backgroundColor: C.white }}>
                {seg.label}
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="octa-footer" style={{ padding: '32px 60px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: C.servizi, flexWrap: 'wrap', gap: '16px' }}>
        <img src="/images/logo_bianco.png" alt="OCTA" style={{ height: '32px', objectFit: 'contain' }} />
        <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.7)' }}>© 2025 OCTA — Online Complete Travel Agency</p>
        <div style={{ display: 'flex', gap: '8px' }}>
          {['trasporto', 'alloggio', 'attivita', 'servizi'].map(k => (
            <span key={k} style={{ width: '12px', height: '12px', borderRadius: '50%', display: 'inline-block', backgroundColor: C[k] }} />
          ))}
        </div>
      </footer>
    </div>
  );
}
